import { LoginUrl } from "config/appUrlConfig";
import { ISecurity, QCCATSessionStorage } from "qccat-ui";
import * as React from "react";

interface AuthContextType {
	user: ISecurity;
	signin: (security: ISecurity) => void;
	signout: () => void;
}

let AuthContext = React.createContext<AuthContextType>(null!);

function AuthProvider({ children }: { children: React.ReactNode }) {
	let hydrateUser = QCCATSessionStorage.getUser();
	let [user, setUser] = React.useState<any>(hydrateUser);

	let signin = (security: ISecurity) => {
		QCCATSessionStorage.setUser(security);
		setUser(security);
	};

	let signout = () => {
		QCCATSessionStorage.removeUser();
		setUser(null);
		window.location.href = LoginUrl;
	};

	let value = { user, signin, signout };

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

function useAuth() {
	return React.useContext(AuthContext);
}

export { useAuth }
export default AuthProvider